import { Player } from "@repo/shared/types";

/* Mirrors PlayerCardView's own BASE_WIDTH, so the placeholder occupies exactly
   the box the real card would have. */
const BASE_WIDTH = 180;

const EMPTY_CARD_URL = `${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc25/my-club/recommendations/empty_card.png`;

/**
 * A player reward whose player has not landed yet. Sets go live on the hour and
 * the player behind one can be a few seconds behind it, so the backend sends an
 * empty player rather than dropping the field — an absent field still means the
 * old payload shape, which falls back to the reward artwork.
 */
export const isPlayerPending = (player?: Player) => !player?.resourceId;

export const EmptyRewardCard = ({ scale }: { scale: number }) => (
  <img
    src={EMPTY_CARD_URL}
    alt=""
    style={{ width: BASE_WIDTH * scale }}
    className="shrink-0"
  />
);
